import { ActivityRoute } from '@serviceandsupport/activity/activity.routes';
import { AssetOverzichtRoute } from '@serviceandsupport/asset-overzicht/asset-overzicht.routes';
import { AssetToolsRoute } from '@serviceandsupport/asset-tools/asset-tools.routes';
import { AssetRoute } from '@serviceandsupport/asset/asset.routes';
import { HqRoute } from '@serviceandsupport/hq/hq.routes';
import { IncidentRoute } from '@serviceandsupport/incident/incident.routes';
import { ItHealthCheckRoute } from '@serviceandsupport/ithealthcheck/ithealthcheck.routes';
import { RequestRoute } from '@serviceandsupport/request/request.routes';
import { IModuleConfig, ISession, MenuKind } from '@simac/ui';

const ballotCheckIcon = 'far fa-ballot-check';

class RouteValidatorForUser {
  static hasBranchId(session: ISession): boolean {
    const branchId = session.custom?.BranchRequestInfo?.branchId;
    return branchId !== undefined && branchId > 0;
  }

  static userExistsInTopdesk(session: ISession): boolean {
    return session?.custom?.SspRequestInfo?.userExistsInTopdesk ?? false;
  }
}

export const ServiceAndSupportModuleConfig: IModuleConfig = {
  name: 'serviceAndSupport',
  injects: [
    {
      name: 'admin',
      components: [
        {
          name: 'Flexy',
          icon: 'far fa-swatchbook',
          translateLabel: 'SSP.MANAGEMENT.FLEXY',
          permission: '',
          pages: [
            {
              isDefault: true,
              route: 'flexy',
              loadComponent: () => import('../../admin/flexy/components/flexy-admin.component').then((m) => m.FlexyAdminComponent),
            },
            {
              isDefault: false,
              route: 'flexy/:flexyId',
              loadComponent: () => import('../../admin/flexy/components/flexy-admin-details.component').then((m) => m.FlexyAdminDetailsComponent),
            },
          ],
        },
      ],
    },
  ],
  routing: {
    menuKind: MenuKind.Main,
    route: 'serviceandsupport',
    children: [
      {
        title: 'MENU.ACTIVITY',
        route: ActivityRoute,
        permission: 'Module.ServiceAndSupport.Activity.View',
        icon: 'far fa-list-tree',
        validForUser(session: ISession) {
          return session.custom?.SspRequestInfo?.userExistsInTopdesk === true;
        },
      },
      {
        title: 'MENU.INCIDENT',
        route: IncidentRoute,
        validForUser: (session) => RouteValidatorForUser.hasBranchId(session) || RouteValidatorForUser.userExistsInTopdesk(session),
        permission: 'Module.ServiceAndSupport.Incident.View',
        icon: 'far fa-comment-alt-exclamation',
      },
      {
        title: 'MENU.REQUEST',
        route: RequestRoute,
        validForUser: (session) => RouteValidatorForUser.hasBranchId(session) || RouteValidatorForUser.userExistsInTopdesk(session),
        permission: 'Module.ServiceAndSupport.Request.View',
        icon: ballotCheckIcon,
      },
      {
        title: 'MENU.REPORT',
        permission: 'Module.Qlik.Qlik.View',
        icon: 'far fa-file-chart-line',
        url: `${location.origin}/redirect/qlik`,
        validForUser: () => window.outerWidth > 992,
      },
      {
        title: 'MENU.OVERVIEW',
        route: HqRoute,
        permission: 'Module.ServiceAndSupport.Hq.View',
        icon: 'far fa-building',
      },
      {
        title: 'MENU.ASSETOVERVIEW',
        route: AssetOverzichtRoute,
        permission: 'Module.ServiceAndSupport.CustomerAsset.View',
        icon: 'far fa-gem',
      },
      {
        title: 'MENU.ASSET',
        route: AssetRoute,
        permission: 'Module.ServiceAndSupport.Asset.View',
        icon: 'far fa-gem',
      },
      {
        title: 'MENU.ASSETTOOLS',
        route: AssetToolsRoute,
        permission: 'Module.ServiceAndSupport.AssetFlow.View',
        icon: 'far fa-tools',
      },
      {
        title: 'MENU.ITHEALTHCHECK',
        route: ItHealthCheckRoute,
        permission: 'Module.ServiceAndSupport.ItHealthCheck.View',
        icon: 'far fa-house-laptop',
      },
    ],
  },
  breadCrumb: {
    hq: [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: '' },
      { key: 'hq', label: '' },
      { key: 'sub', label: '', hide: true },
      { key: 'details', label: '' },
      { key: 'sub', label: '', hide: true },
      { key: 'activity', label: '' },
    ],
    request: [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: '' },
      { key: 'details', label: '' },
      { key: 'sub', label: '', hide: true },
      { key: 'activity', label: '' },
    ],
    activity: [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: '' },
      { key: 'activity', label: '' },
    ],
    asset: [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: 'MENU.ASSET' },
      { key: 'type', label: '' },
      { key: 'details', label: '' },
      { key: 'asset', label: '' },
    ],
    'customer-asset-overzicht': [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: 'MENU.ASSETOVERVIEW' },
      { key: 'type', label: '', hide: true },
      { key: 'asset', label: '' },
      { key: 'details', label: '' },
      { key: 'incident', label: '' },
    ],
    incident: [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: 'MENU.INCIDENT' },
      { key: 'details', label: '' },
    ],
    default: [
      { key: 'ssp', label: '', hide: true },
      { key: 'page', label: '' },
      { key: 'details', label: '' },
    ],
  },
};
